import api from './apiService';
import { API_PATHS } from '../constants/portalApiPath';

const appointmentService = {
  getList: (data) => api.post(API_PATHS.APPOINTMENT, data),
  add: (data) => api.post(API_PATHS.APPOINTMENT_ADD, data),
  markStatus: (data) => api.post(API_PATHS.APPOINTMENT_MARK_STATUS, data),
  cancel: (data) => api.post(API_PATHS.APPOINTMENT_CANCEL, data),
  checkCancel: (data) => api.post(API_PATHS.APPOINTMENT_CANCEL_CHECK, data),
  checkCancelSeries: (data) => api.post(API_PATHS.APPOINTMENT_CANCEL_SERIES_CHECK, data),
  cancelSeries: (data) => api.post(API_PATHS.APPOINTMENT_CANCEL_SERIES, data),
  checkConflicts: (data) => api.post(API_PATHS.APPOINTMENT_CHECK_CONFLICTS, data),
  getAvailableSlots: (data) => api.post(API_PATHS.APPOINTMENT_AVAILABLE_SLOTS, data),
  previewFee: (data) => api.post(API_PATHS.APPOINTMENT_PREVIEW_FEE, data),
  transitionStatus: (data) => api.post(API_PATHS.APPOINTMENT_TRANSITION, data),
  getTherapistSchedules: (data) => api.post(API_PATHS.APPOINTMENT_THERAPIST_SCHEDULES, data),
  updateTherapistSchedule: (data) => api.post(API_PATHS.APPOINTMENT_THERAPIST_SCHEDULES_UPDATE, data),
  updateNotes: (data) => api.post(API_PATHS.APPOINTMENT_UPDATE_NOTES, data),
  updateDate: (data) => api.post(API_PATHS.APPOINTMENT_UPDATE_DATE, data),
  reschedule: (data) => api.post(API_PATHS.APPOINTMENT_RESCHEDULE, data),
  // A guest online session (not a patient; paid at booking) and the Patients › Guests list.
  bookGuest: (data) => api.post(API_PATHS.APPOINTMENT_GUEST_BOOK, data),
  listGuests: (data) => api.post(API_PATHS.APPOINTMENT_GUEST_LIST, data),
  findGuest: (data) => api.post(API_PATHS.APPOINTMENT_GUEST_LOOKUP, data),
  rescheduleRateCheck: (data) => api.post(API_PATHS.APPOINTMENT_RESCHEDULE_RATE_CHECK, data),
  // Change a series' therapy from a date (ChangeTherapyModal): the read-only preview, then the
  // commit with the preview's fingerprint. The dialog says what went wrong itself (skipErrorToast).
  changeTherapyCheck: (data) => api.post(API_PATHS.APPOINTMENT_CHANGE_THERAPY_CHECK, data, { skipErrorToast: true }),
  changeTherapy: (data) => api.post(API_PATHS.APPOINTMENT_CHANGE_THERAPY, data, { skipErrorToast: true }),
  changeSessionTypeCheck: (data) => api.post(API_PATHS.APPOINTMENT_CHANGE_SESSION_TYPE_CHECK, data, { skipErrorToast: true }),
  changeSessionType: (data) => api.post(API_PATHS.APPOINTMENT_CHANGE_SESSION_TYPE, data, { skipErrorToast: true }),
  previewBulkDeleteByMonth: (data) => api.post(API_PATHS.APPOINTMENT_BULK_DELETE_PREVIEW, data),
  deleteByMonth: (data) => api.post(API_PATHS.APPOINTMENT_DELETE_BY_MONTH, data),
  // Google Meet — the appointment detail panel says what went wrong itself (skipErrorToast).
  getGoogleMeet: (data) => api.post(API_PATHS.APPOINTMENT_GOOGLE_MEET, data, { skipErrorToast: true }),
  enableGoogleMeet: (data) => api.post(API_PATHS.APPOINTMENT_GOOGLE_MEET_ENABLE, data, { skipErrorToast: true }),
  disableGoogleMeet: (data) => api.post(API_PATHS.APPOINTMENT_GOOGLE_MEET_DISABLE, data, { skipErrorToast: true }),
  retryGoogleMeet: (data) => api.post(API_PATHS.APPOINTMENT_GOOGLE_MEET_RETRY, data, { skipErrorToast: true }),
};

export default appointmentService;
